import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('component.nav.sidebar');
import { OnInit } from '@angular/core';
import { HostListener } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-component-nav-sidebar',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/component.nav.sidebar/view.scss */
/* src/app/component.nav.sidebar/view.scss: no such file or directory */`],
})
export class ComponentNavSidebarComponent implements OnInit {
    public ticketStats: any = {};

    constructor(@Inject( Service) public service: Service) { }

    public async ngOnInit() {
        await this.service.init();
        await this.loadTicketStats();
    }

    @HostListener('document:click')
    public clickout() {
        this.service.status.toggle('navbar', true);
    }

    public isActive(link: string) {
        const path = location.pathname || '';
        if (link === '/tickets') {
            return path === '/tickets' || path.indexOf('/tickets/') === 0;
        }
        if (link === '/tickets-g') {
            return path === '/tickets-g' || path.indexOf('/tickets-g/') === 0;
        }
        return path === link || path.indexOf(`${link}/`) === 0;
    }

    private itemClass(active: boolean) {
        if (active) {
            return "group flex w-full gap-x-2 items-center rounded-md bg-gray-100 px-2 py-1.5 text-[13px] font-medium text-indigo-600";
        }
        return "group flex w-full gap-x-2 items-center rounded-md px-2 py-1.5 text-[13px] font-medium text-gray-600 hover:bg-gray-50 hover:text-indigo-600";
    }

    public activeClass(link: string) {
        return this.itemClass(this.isActive(link));
    }

    private currentTicketStatus() {
        return new URLSearchParams(location.search).get('status') || '';
    }

    private currentTicketVariant() {
        return new URLSearchParams(location.search).get('variant') || '';
    }

    private isTicketStatus(status: string) {
        const current = this.currentTicketStatus();
        if (status === '') {
            return current === '';
        }
        if (status === 'infra_processing') {
            return current === 'infra_processing' || current === 'in_progress';
        }
        return current === status;
    }

    private isLegacyTicketPage() {
        const path = location.pathname || '';
        return path === '/tickets' || path.indexOf('/tickets/') === 0;
    }

    private isGTicketPage() {
        const path = location.pathname || '';
        return path === '/tickets-g' || path.indexOf('/tickets-g/') === 0;
    }

    public ticketStatusClass(status: string) {
        return this.itemClass(this.isLegacyTicketPage() && !this.currentTicketVariant() && this.isTicketStatus(status));
    }

    public ticketVariantClass(variant: string) {
        return this.itemClass(this.isLegacyTicketPage() && this.currentTicketVariant() === variant);
    }

    public ticketGClass() {
        return this.itemClass(this.isGTicketPage());
    }

    public ticketStatusCount(key: string) {
        return this.ticketStats?.[key] || 0;
    }

    public async loadTicketStats() {
        try {
            const { code, data } = await wiz.call('ticket_stats', {});
            if (code === 200) {
                this.ticketStats = data.stats || {};
                await this.service.render();
            }
        } catch (e) {
            this.ticketStats = {};
        }
    }

    public isAdmin() {
        return this.service.auth.check.role('admin');
    }
}

export default ComponentNavSidebarComponent;